const formatters = new Map();

export function formatLocalDatetime(instant, locale, format, options, Formatter = Intl.DateTimeFormat) {
  const key = `${locale}:${format}`;

  if (!formatters.has(key)) formatters.set(key, new Formatter(locale, options));

  return formatters.get(key).format(instant);
}

export function clearDatetimeFormatters() {
  formatters.clear();
}
